const checkRouteMatches = (route, { type, value }) => {
  switch (type) {
    case 'regex':
      return new RegExp(value).test(route)
    case 'prefix':
      return route.startsWith(value)
    default:
      return false
  }
}

/**
 *
 * @param {Context} - ctx Nuxt context
 */
export default function ({ app, route, $config }) {
  /**
   * @type {ModuleOptions} options - Nuxt module options
   */
  const options = JSON.parse('{"rules":[{"type":"regex","value":"^/(?:(?:en|de|fr)/?)?$"},{"type":"prefix","value":"/compare"},{"type":"prefix","value":"/en/compare"},{"type":"prefix","value":"/vergleichen/"},{"type":"prefix","value":"/de/vergleichen/"},{"type":"prefix","value":"/comparer"},{"type":"prefix","value":"/fr/comparer"}]}') || {
    rules: []
  };

  app.router?.beforeEach((to, from, next) => {
    // Disable in non-production environments
    if (process.env.NODE_ENV !== 'production') {
      return next();
    }

    const isExternalRoute = options.rules.some(config => checkRouteMatches(to.path, config))

    if (to.fullPath === from.fullPath || !isExternalRoute) {
      return next();
    }

    window.location.href = to.fullPath
  });
}
